import EcoEmail from 'eco-design/elements/eco-email';
import dayjs from 'dayjs';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';

const CONTACT_LIST_ID_MAP: Record<string, string> = {
    us: '1487185288',
    au: '1388453392',
};

const A_IMAGE_MAP: Record<string, { pc: string; pad: string; h5: string }> = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1768186300302/home-carousel-banner.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1768186300485/home-carousel-banner%20(2).jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1768186300142/home-carousel-banner%20(1).jpg',
    },
    au: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785310025138-8wv614-compressed-home-carousel-banner.webp',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1786093613685-vx4pqe-compressed-home-carousel-banner.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1786093807144-fv9kni-compressed-home-carousel-banner.webp',
    },
};

function TheComp() {
    const { getSystemTime } = useGlobal();
    const { locale = 'us' } = getLocal();
    const { t } = useLang('costsaving-new');
    const images = A_IMAGE_MAP[locale] || A_IMAGE_MAP.us;

    const systemTime = getSystemTime();
    const date = dayjs(systemTime).format('YYYY-MM-DD') as any;
    const FIELDS_MAP: Record<string, any[]> = {
        us: [
            {
                type: 'single',
                id: '4423',
                value: 1,
                overwrite: true,
            },
            {
                type: 'single',
                id: '31',
                value: 1,
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '9435',
                value: [10],
                overwrite: false,
            },
            {
                type: 'text',
                id: '9625',
                value: date,
                overwrite: false,
            },
        ],
        au: [
            {
                type: 'single',
                id: '4433',
                value: 1,
                overwrite: true,
            },
            {
                type: 'single',
                id: '31',
                value: 1,
                overwrite: true,
            },
            {
                type: 'multiple',
                id: '9537',
                value: [25], // 场景页_CostSaving
                overwrite: false,
            },
        ],
    };

    const contactListId = CONTACT_LIST_ID_MAP[locale] || CONTACT_LIST_ID_MAP.us;
    const fields = FIELDS_MAP[locale] || FIELDS_MAP.us;
    const termsHtml =
        locale === 'au'
            ? `* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-au/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`
            : `* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://us.ecoflow.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`;

    return (
        <section
            className={`${css.section} cost-saving-A GtmModuleData-section`}
            id="cost-saving-A"
            data-section-id={'cost-saving-A'}
            data-section-title={t('A_title')}
        >
            <div className="A-img">
                <EcoImg className="picture" pc={images.pc} pad={images.pad} h5={images.h5} alt={t('A_title')} />
            </div>

            <div className="A-info">
                <div className="A-title">{t('A_title')}</div>
                <div className="A-desc">{t('A_desc')}</div>
                <EcoEmail
                    contactListId={[contactListId]}
                    fields={fields}
                    defaultTermsCheck
                    tipsObj={{
                        placeholder: t('A_email_placeholder'),
                    }}
                    termsHtml={termsHtml}
                />
            </div>
        </section>
    );
}

export default TheComp;
